// Dev-only Agentation widget (T-038, plan §11 step 8, spec §8.1).
//
// Renders only when `import.meta.env.DEV` is true. Vite tree-shakes
// the body in production builds because the conditional is a
// build-time constant, so the production bundle gets the early
// `null` return and skips importing this component's children.
//
// The actual `agentation` package isn't on npm — the spec lists it
// as the floating chip from the prototype's screenshot. Until the
// owner ships a real component, we render a minimal placeholder
// that's invisible in production and provides a click-to-toggle
// chip with a "Dev" tag in development.

import { useState } from 'react';
import { Sparkles, X } from 'lucide-react';

export function AgentationWidget() {
  // Compile-time gate. In production builds Vite replaces
  // `import.meta.env.DEV` with `false`, and the tree-shaker drops the
  // rest of the module — keeping the production bundle clean.
  if (!import.meta.env.DEV) return null;

  return <DevWidgetBody />;
}

function DevWidgetBody() {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="fixed bottom-4 right-4 z-[60]"
      data-testid="agentation-widget"
    >
      {open ? (
        <div
          className="bg-slate-900 text-white rounded-2xl shadow-xl p-4 w-72"
          data-testid="agentation-widget-panel"
        >
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-start gap-2">
              <Sparkles size={16} className="text-violet-300 mt-0.5" />
              <div>
                <p className="text-sm font-semibold">Agentation (dev)</p>
                <p className="text-xs text-white/60 mt-1">
                  Local-dev assistant placeholder. Replace with the
                  real <code>agentation</code> component when it
                  ships.
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={() => setOpen(false)}
              aria-label="Close Agentation"
              className="text-white/60 hover:text-white -mt-1"
              data-testid="agentation-widget-close"
            >
              <X size={14} />
            </button>
          </div>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="Open Agentation (dev only)"
          data-testid="agentation-widget-trigger"
          className="bg-slate-900 text-white rounded-full shadow-lg px-3 py-2 flex items-center gap-2 text-xs font-bold hover:bg-slate-800"
        >
          <Sparkles size={14} className="text-violet-300" />
          Agentation
          <span className="ml-1 text-[9px] uppercase tracking-widest text-violet-300/80">
            Dev
          </span>
        </button>
      )}
    </div>
  );
}
